import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125ce6d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.event && _ctx.routeChoice(_ctx.event))),
        style: _normalizeStyle([_ctx.event ? { cursor: 'pointer' } : null])
      }, [
        _withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.name), 513), [
          [_vShow, !this.$route.path.includes('event')]
        ]),
        _createElementVNode("h5", {
          style: _normalizeStyle(this.$route.path.includes('event') ? { margin: '10px 0' } : {})
        }, _toDisplayString(_ctx.date) + " · " + _toDisplayString(_ctx.hour), 5),
        _createElementVNode("h3", null, _toDisplayString(_ctx.place), 1)
      ], 4),
      _withDirectives(_createVNode(_component_Button, {
        link: _ctx.link,
        padd: "10px 20px",
        text: this.$store.state.language === 'fr' ? 'Billetterie' : 'Tickets',
        mainColor: "var(--colorPrimary)",
        hoverColor: "var(--colorPrimaryDark)"
      }, null, 8, ["link", "text"]), [
        [_vShow, this.link]
      ])
    ]),
    _hoisted_2
  ], 64))
}